import { useControls } from 'leva'
import { experiences } from './data/PortfolioData'
import { isMobile } from './Utils'

export default function ScrollController() {
    // console.log("recreating ScrollController! calling return")

    // check `// magic numbers` for more too :(

    const ctrls = useControls('magic numbers', {
        // camera
        cameraLerpFactor: {
            value: 0.2,
            min: 0.01,
            max: 0.6,
            step: 0.1,
        },

        // sections
        bioSectionCameraUnitsHeight: {
            value: 4.0, // 3.0
            min: 2.0,
            max: 20.0,
            step: 0.5,
        },
        oneExperienceCameraUnitsHeight: {
            // value: 0.25,
            value: 0.5,
            // value: 1.0,
            min: 0.1,
            max: 2.0,
            step: 0.01,
        },
        contactSectionCameraUnitsHeight: {
            // this section is slightly larger than bio because the tube has a bit of offset scale to hide the last part of the ramp ball (related to contactSectionOffsetY)
            value: 5.0,
            min: 0.0,
            max: 10.0,
            step: 0.01,
        },

        // offsets
        topCircleOffsetY: {
            value: 0.12,
            min: -2.0,
            max: 2.0,
            step: 0.01,
        },
        startExperiencesCameraUnitsOffset: {
            value: 2.0,
            min: 0.0,
            max: 10.0,
            step: 0.01,
        },
        endExperiencesCameraUnitsOffset: {
            value: 2.5,
            min: 0.0,
            max: 10.0,
            step: 0.01,
        },
        experiencesContainerOffsetY: {
            value: 0.15,
            min: -2.0,
            max: 2.0,
            step: 0.01,
        },
        ballRampOffsetZ: {
            value: 0.1,
            min: -2.0,
            max: 2.0,
            step: 0.01,
        },
        ballOverRampOffsetZ: {
            value: 0.68,
            min: -2.0,
            max: 2.0,
            step: 0.01,
        },
        contactSectionOffsetY: {
            value: 0.5,
            min: -2.0,
            max: 2.0,
            step: 0.01,
        },

        startFallingBallOffset: {
            // with this offset we make the effect that the ball falls down after the rotation of the top circle
            value: 0.6,
            min: -2.0,
            max: 2.0,
            step: 0.01,
        },
        finalBallOffsetY: {
            value: 0.0,
            min: -2.0,
            max: 2.0,
            step: 0.01,
        },
    })

    if (isMobile()) {
        ctrls.bioSectionCameraUnitsHeight = 15.0
        ctrls.contactSectionCameraUnitsHeight = 0.0
        ctrls.finalBallOffsetY = 1.0
    }

    let startBioSectionCameraUnits = 0
    let startExperiencesSectionCameraUnits = ctrls.bioSectionCameraUnitsHeight / 2.0 // after bio section

    const totalExperiencesRotationCameraUnitsHeight = ctrls.oneExperienceCameraUnitsHeight * (experiences.length - 1)

    const initialLetBallFixedInsideRingCameraUnits = startBioSectionCameraUnits + ctrls.startFallingBallOffset
    const initialFallingBallCameraUnits = startExperiencesSectionCameraUnits + 1.25

    const startExperiencesRotationCameraUnits = startExperiencesSectionCameraUnits + ctrls.startExperiencesCameraUnitsOffset
    const endExperiencesRotationCameraUnits = startExperiencesRotationCameraUnits + totalExperiencesRotationCameraUnitsHeight

    const finalStopRotatingBallCameraUnits = endExperiencesRotationCameraUnits + ctrls.oneExperienceCameraUnitsHeight * 2.0

    const middleExperiencesSectionOffsetY = startExperiencesSectionCameraUnits + ctrls.startExperiencesCameraUnitsOffset + totalExperiencesRotationCameraUnitsHeight

    const centerTubeOffsetY = -ctrls.bioSectionCameraUnitsHeight / 2.0
    const centerTubeScaleY = totalExperiencesRotationCameraUnitsHeight + ctrls.startExperiencesCameraUnitsOffset + ctrls.endExperiencesCameraUnitsOffset

    const startContactSectionCameraUnits = startExperiencesSectionCameraUnits + middleExperiencesSectionOffsetY

    const total3DExperienceCameraUnitsHeight = ctrls.bioSectionCameraUnitsHeight + middleExperiencesSectionOffsetY + ctrls.contactSectionCameraUnitsHeight
    const totalCameraScrollCameraUnits = total3DExperienceCameraUnitsHeight - (ctrls.bioSectionCameraUnitsHeight + ctrls.contactSectionCameraUnitsHeight) / 2.0

    // console.log("ScrollController. bioSectionCameraUnitsHeight: " + ctrls.bioSectionCameraUnitsHeight)
    // console.log("ScrollController. contactSectionCameraUnitsHeight: " + ctrls.contactSectionCameraUnitsHeight)
    // console.log("ScrollController. oneExperienceCameraUnitsHeight: " + ctrls.oneExperienceCameraUnitsHeight)
    // console.log("ScrollController. middleExperiencesSectionOffsetY: " + middleExperiencesSectionOffsetY)
    // console.log("ScrollController. total3DExperienceCameraUnitsHeight: " + total3DExperienceCameraUnitsHeight)

    // console.log("ScrollController. startExperiencesRotationCameraUnits: " + startExperiencesRotationCameraUnits)
    // console.log("ScrollController. endExperiencesRotationCameraUnits: " + endExperiencesRotationCameraUnits)
    // console.log("ScrollController. experiencesCameraUnitsHeight: " + totalExperiencesRotationCameraUnitsHeight)
    // console.log("ScrollController. startContactSectionCameraUnits: " + startContactSectionCameraUnits)

    return [
        ctrls.cameraLerpFactor,

        totalCameraScrollCameraUnits,
        ctrls.bioSectionCameraUnitsHeight,
        ctrls.contactSectionCameraUnitsHeight,
        ctrls.oneExperienceCameraUnitsHeight,

        ctrls.topCircleOffsetY,
        centerTubeOffsetY,
        centerTubeScaleY,
        ctrls.startExperiencesCameraUnitsOffset,
        ctrls.experiencesContainerOffsetY,
        ctrls.ballRampOffsetZ,
        ctrls.ballOverRampOffsetZ,
        ctrls.contactSectionOffsetY,

        initialLetBallFixedInsideRingCameraUnits,
        initialFallingBallCameraUnits,
        ctrls.finalBallOffsetY,
        startExperiencesRotationCameraUnits,
        endExperiencesRotationCameraUnits,
        totalExperiencesRotationCameraUnitsHeight,
        finalStopRotatingBallCameraUnits,

        startContactSectionCameraUnits,
    ]
}
